import { render, staticRenderFns } from "./AuthResult.vue?vue&type=template&id=9c20d222"
import script from "./AuthResult.vue?vue&type=script&lang=js"
export * from "./AuthResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports